import React, { useContext } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import colors from '../../../../themes/main-colors';
import { CustomDialog } from '../common/custom-dialog';
import { useIsMobile } from '../../../../util/style-utils';
import BoltIcon from '../../../../static/icon-bolt.svg';
import { ReportOutageMeterOn } from '../report-outage-meter-on/ReportOutageMeterOn';
import { ReportOutageMeterOff } from '../report-outage-meter-off/ReportOutageMeterOff';
import { OutageLeftPanelStateContext } from '../../providers/OutageLeftPanelStateProvider';

export const ReportOutage = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const context = useContext(OutageLeftPanelStateContext);
  const meterStatus =
    context?.selectedAccountForOutage?.premiseInfos?.[0]
      ?.servicePointDetails?.[0]?.meter?.status;
  return (
    <CustomDialog
      open={context?.reportOutageOpen || false}
      onClose={() => context?.setReportOutageOpen(false)}
      title={t('REPORT_OUTAGE')}
      dialogWidth={'800px'}
      titleBgColor={isMobile ? '' : colors.riverBlue}
      titleTextColor={isMobile ? '' : colors.noirBlur}
      titleIcon={isMobile ? <BoltIcon /> : ''}
    >
      {/* commenting this piece of code as all meter status is considered to be on */}
      {/* {meterStatus === 'Unknown' ? ( */}
      <ReportOutageMeterOn />
      {/* ) : (
        <ReportOutageMeterOff />
      )} */}
    </CustomDialog>
  );
};
